module.exports = __webpack_public_path__ + "img/hito004.984ca6d0.webp";